// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_m5-0";
export var animationContainer = "_m5-1";
export var itemPrice = "_m5-a";
export var itemizedContent = "_m5-9";
export var itemizedHeader = "_m5-7";
export var itemizedRow = "_m5-8";
export var itemizedSection = "_m5-6";
export var modalContent = "_m5-2";
export var orderName = "_m5-3";
export var refundOption = "_m5-4";
export var refundOptionsContainer = "_m5-5";
export var shippingLabel = "_m5-b";
export var totalRow = "_m5-c";